module.exports = function () {
  return "\n    <section data-panel=\"browse\" class=\"is-active\"></section>\n    <section data-panel=\"my-listings\"></section>\n    <section data-panel=\"sales\"></section>\n    <section data-panel=\"withdrawals\"></section>\n    <section data-panel=\"moderate\"></section>\n  ";
};